import React, { Component } from 'react';
import ChapterBlock from './chapter-block';

class EmptyBlock extends Component {
  render() {
    const {
      emptyMasteryBlock,
      goalIndex,
      blockType,
      dependencyDataList,
      linkedDataList,
      nodeDataList,
      isLastBlock,
    } = this.props;

    return (
      <ChapterBlock
        key={emptyMasteryBlock.id}
        {...emptyMasteryBlock}
        goalIndex={goalIndex}
        blockType={blockType}
        dependencyDataList={dependencyDataList}
        linkedDataList={linkedDataList}
        nodeDataList={nodeDataList}
        isLastBlock={isLastBlock}
      />
    );
  }
}

export default EmptyBlock;
